import { adjustRiskZoneV2KeyToNumber } from '@/helpers/riskZoneMethods';
import { ChartData, ChartPoint, DataItemToMap } from '@/types/chartPoint';
import { IRiskZoneV2LimitedDTO } from '@/types/riskZone';

export const mapChainDataWithZ = (data: Array<DataItemToMap>): ChartData => {
  let mapped: ChartData = [];

  mapped = data
    .filter(item => item.value !== null)
    .map(item => {
      return {
        x: new Date(`${item.timestamp}Z`).getTime(),
        y: item.value,
      };
    });

  return mapped;
};

export const mapRiskZoneV2ChartData = (data: Array<IRiskZoneV2LimitedDTO>): ChartData => {
  let mapped: ChartPoint[] = [];
  mapped = data
    .filter(item => item?.value)
    .map(item => {
      return {
        x: new Date(`${item.timestamp}Z`).getTime(),
        y: adjustRiskZoneV2KeyToNumber(item.value),
      };
    });

  return mapped;
};
